import React from 'react';
import { useRouter } from 'next/router';
import { useSiteContext } from '../components/SiteContext';
import JobApplication from '../components/Jobs/Apply';
import withApollo from '../lib/apollo';
import withQuery from '../lib/withQuery';
import applyForJob from '../lib/queries/jobs/applyForJobQuery.graphql';
import getJobsLocale from '../lib/getJobsLocale';
import jobActiveQuery from '../lib/queries/jobs/jobActiveQuery.graphql';
import throw404 from '../lib/throw404';
import redirectJobSlug from '../lib/redirectJobSlug';

const JobApplicationWithQuery = withQuery(JobApplication);

export const JobApplicationPage = () => {
  const { id } = useRouter().query;
  const {
    jobsLocale, prefix, url,
  } = useSiteContext();

  return (
    <JobApplicationWithQuery
      query={applyForJob}
      variables={{ id: Number(id), locales: [jobsLocale] }}
      errorMessage="Error while loading job..."
      prefix={prefix}
      url={url}
    />
  );
};

JobApplicationPage.getInitialProps = async ({
  req, apolloClient, query: { id, slug, prefix }, res,
}) => {
  if (!req) return {};

  const { locale } = req;
  const { data: { job } } = await apolloClient.query({
    variables: {
      id: Number(id),
      locales: [getJobsLocale(locale)],
    },
    fetchPolicy: 'network-only',
    query: jobActiveQuery,
  });

  if (!job || !job.active) { return throw404(); }

  return redirectJobSlug(
    job,
    slug,
    id,
    prefix,
    `job-apply.${locale}`,
    res,
  );
};

export default withApollo(JobApplicationPage);
